import { useEffect } from 'react'
import { getAllCurrencies } from '../../../services/sBook/currency.service';

const useGetCurrencies = (currenties, setCurrenties) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllCurrencies();
                const response = serviceResponse.data;

                const aux = [];

                if (response.succeeded) {
                    response.data.forEach(element => {
                        aux.push({ key: element.id, text: element.name, title:  element.name})
                    });
                }

                setCurrenties(aux);
            }
            catch (error) {
                setCurrenties([]);
            }
        }
        
        if (currenties === null) {
            getData()
        }
    }, [currenties, setCurrenties]);
}

export {
    useGetCurrencies
}